export const footprint = {
  title: "足跡",
  empty: "足跡がまだありません",
} as const;
